import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Customer } from 'src/app/models/customer.model';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { CustomerEditFormComponent } from '../customer-edit-form/customer-edit-form.component';
import { getCustomerInitials, stringToHexColor } from 'src/utils/display';
import { Rider } from 'src/app/models/rider.model';
import { RiderEditFormComponent } from '../rider-edit-form/rider-edit-form.component';


@Component({
  selector: 'ubc-model-search',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CustomerEditFormComponent, RiderEditFormComponent],
  templateUrl: './model-search.component.html',
  styleUrl: './model-search.component.scss'
})
export class ModelSearchComponent {
  @Input() model: "customer" | "rider" = "customer"
  @Input() customer?: Customer
  @Output() modelWasPicked: EventEmitter<Customer | Rider | undefined> = new EventEmitter<Customer | Rider | undefined>()

    creatingModel: boolean = false
    selectedModel?: Customer | Rider
    colors: string[] = [];
    newModelForm: FormGroup
    searchControl: FormControl = new FormControl('');
  
    options: Customer[] = []
  
    listOpen = false
  
    constructor(
      private apiService: APIServiceService
    ){}
  
    ngOnInit(){
      // console.log({options: this.options})
      // this.selectedCustomer = this.options[3]

     
  
      this.searchControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(term => {
        this.searchForModel(term)
        .then(results => {
          this.options = results
          console.log(this.options)
        })
      })
  
      
    }
  
    getInitials(result: any){
      if(this.model === "customer"){
        return getCustomerInitials(result as Customer)
      }

      if(this.model === "rider"){
        return (result as Rider).name.charAt(0)
      }
    }
  
    stringToHexColor(result: any): string {
      if(this.model === "customer"){
        return stringToHexColor((result as Customer).firstName)
      }
      if(this.model === "rider"){
        return stringToHexColor((result as Rider).name)
      }
    }
  
    // getInitials(customer: Customer){
    //   let out = ""
  
    //   if(customer.firstName){
    //     out += customer.firstName.charAt(0)
    //   }
  
    //   if(customer.lastName){
    //     out += customer.lastName.charAt(0)
    //   }
  
    //   return out
    // }
  
    // hashStringToNumber(str: string): number {
    //   let hash = 0;
    //   for (let i = 0; i < str.length; i++) {
    //     const char = str.charCodeAt(i);
    //     hash = (hash << 5) - hash + char;
    //     hash |= 0; // Convert to 32bit integer
    //   }
    //   return hash - 1000
    // }
    
    // stringToHexColor(str: string): string {
    //   const hash = this.hashStringToNumber(str);
    //   // Convert the hash number to a hex string
    //   let color = ((hash >> 24) & 0xFF).toString(16) +
    //               ((hash >> 16) & 0xFF).toString(16) +
    //               ((hash >> 8) & 0xFF).toString(16) +
    //               (hash & 0xFF).toString(16);
    //   // Ensure it's 6 characters long
    //   color = color.padStart(6, '0');
    //   // Return the hex color with a leading '#'
    //   return `#${color.substring(0, 6)}`;
    // }
  
    createNewCustomerClicked(){
      this.creatingModel = true
      if(this.model === "customer"){
        this.newModelForm = new FormGroup({
          firstName: new FormControl('', Validators.required),
          lastName: new FormControl("", Validators.required),
          email: new FormControl("", [Validators.required, Validators.email]),
          tel: new FormControl("", Validators.required),
          billingAddress1: new FormControl(""),
          billingAddress2: new FormControl(""),
          billingTown: new FormControl(""),
          billingCity: new FormControl(""),
          billingPostcode: new FormControl(""),
          notes: new FormControl("")
        })
      }

      if(this.model === "rider"){
        this.newModelForm = new FormGroup({
          name: new FormControl('', Validators.required)
        })
      }
    }
  
    toggleList(){
      this.listOpen = !this.listOpen
    }
  
    createCustomerSubmit(){
      this.newModelForm = undefined
      this.creatingModel = false
    }
  
    async searchForModel(term: string): Promise<Customer[]>{
  
      if(term === ""){
        return []
      }
  
      try {
        let response
        
        if(this.model === "customer"){
          response = await this.apiService.customer.search(term.toLowerCase())
        }

        if(this.model === "rider"){
          response = await this.apiService.riders.search(term.toLocaleLowerCase(), this.customer?.id)
        }
        
        this.listOpen = true
        
        if(!response.success || !response.data || response.data.results.length === 0){
          return []
        }
  
        
  
        return response.data.results.map((result) => {
          if(this.model === "customer"){
            return new Customer().deserialize(result)
          }

          if(this.model === "rider"){
            return new Rider(result.id, result.name, result.weightKg, result.heightCm)
          }

          return {}
        })
      } catch(e){
        console.log(e)
        return []
      }
  
      const results = [
        new Customer().deserialize({ firstName: "Joel", lastName: "Spencer", id: 1, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Ruth", lastName: "Spencer", id: 2, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Ettie", lastName: "Spencer", id: 3, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Andy", lastName: "Goodwin", id: 4, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Graham", lastName: "Tennant", id: 5, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Muzzle", lastName: "Spencer", id: 6, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Boss", lastName: "Spencer", id: 7, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Ettie", lastName: "Spencer", id: 8, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Andy", lastName: "Goodwin", id: 9, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Graham", lastName: "Tennant", id: 10, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Muzzle", lastName: "Spencer", id: 11, email: "test@test.com"}),
        new Customer().deserialize({ firstName: "Boss", lastName: "Spencer", id: 12, email: "test@test.com"})
      ]
  
      if(term === ""){
        return []
      }
  
      this.listOpen = true
  
      return results.filter((customer) => {
        console.log(`Searching for customer ${term}`)
        return customer.firstName.toLowerCase().includes(term.toLowerCase())
      })
    }
  
    async modelPicked(result: Customer | Rider){
      this.selectedModel = result
      this.listOpen = false

      this.creatingModel = false
      
      if(this.model === "customer"){
        
        const customerResponse = await this.apiService.customer.getByID((result as Customer).id)
        this.modelWasPicked.emit( customerResponse.data )
      }

      if(this.model === "rider"){
        const riderResponse = await this.apiService.riders.getByID((result as Rider).id)
        this.modelWasPicked.emit( riderResponse.data )
      }
    }
  
    modelCreateCancelled(){
      this.selectedModel = undefined
      this.creatingModel = false
    }
  
    newModelCreated(result: any){
      this.selectedModel = result
      this.modelWasPicked.emit(result)
    }


    getResultDisplayname(result: any){
      if(this.model === "customer"){
        return (result as Customer).getFullName()
      }

      if(this.model === "rider"){
        return (result as Rider).name
      }

      return "result"
    }

}
